import React from "react";
import {Button} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {ModalActions} from "../../../Store/Modal/Slice";
import {PICKUP_MODAL} from "../../../Store/Modal/Types";
import {ContactsActions} from "../../../Store/Contact/Slice";
import {RootState} from "../../../Store/Reducers";
import {Customer} from "../../../Models/Customer";
import {PaymentTypeActions} from "../../../Store/PaymentType/Slice";
import {PackingTypesActions} from "../../../Store/PackingType/Slice";

const NewShipmentComponent = () => {

  const dispatch = useDispatch();

  const {
    CompanyReducer: {company_selected, branch_selected},
    PackingReducer: {packingTypes},
    PaymentReducer: {paymentTypes}
  } = useSelector((state: RootState) => state);

  const openNewShipmentModal = () => {
    dispatch(ModalActions.openModal({modal:PICKUP_MODAL}));
    dispatch(ContactsActions.getContacts({customer:(branch_selected as Customer)?._KEY || (company_selected as Customer)?._KEY}));
    !paymentTypes.length && dispatch(PaymentTypeActions.getPaymentTypes());
    !packingTypes.length && dispatch(PackingTypesActions.getPackingTypes());
  };

  return(
    <div className="px-3">
      <Button  className="default-font outline-none" onClick={openNewShipmentModal} color="secondary">Nuevo envio</Button>
    </div>
  );
};

export default NewShipmentComponent;
